module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="fmcy-cart-delivery-tip-wrapper container-fluid">\n    <div class="row fmcy-cart-tip-expanded-details">\n        <div class="col-xs-12">\n          <div class="fmcy-cart-delivery-tip-title">Tip</div>\n          <div class="fmcy-cart-delivery-tip-header">Love our service, tip us. Thanks!</div>\n        </div>\n    </div>\n\n    <div class="row">\n        <div class="col-xs-12">\n            <div class="fmcy-cart-delivery-tip-button-toggle-region"></div>\n        </div>\n    </div>\n</div>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/cart/cart-delivery-address/cart-delivery-tip/cart-delivery-tip.html
 ** module id = 637
 ** module chunks = 1 9 15 101
 **/